import { Component, OnInit } from '@angular/core';
import { UserState } from '../../shared/states/user.state';

@Component({
  selector: 'app-register-schedule',
  templateUrl: './register-schedule.component.html',
  styleUrls: ['./register-schedule.component.css']
})
export class RegisterScheduleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
